
const NotesPageLoggedOutView=()=>{
    return (
        <p>Please Login to see your notes.</p>
    )
}

export default NotesPageLoggedOutView;
